let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kDPsc"), load("jh0xO")]).then(() => parcelRequire('6vWxb'));